<template>
    <div class="!my-0 mx-24 py-24">
        <JobBoardList
            :has-multi-posting-subscription="hasMultiPostingSubscription"
            @change-tab="$emit('change-tab', {tab: 'Campaigns', params: 'create'})"
            @add-to-campaign="addToCampaign"
        />
    </div>
</template>

<script>
import SimpleButton from "../components/ui/SimpleButton.vue";
import PaidSubscription from "../models/PaidSubscription";
import JobBoardList from "../components/multiposting/JobBoardList.vue";
import {mapActions, mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../state/store';
import {useMultiPostingStore} from '../state/modules/multiPosting';

export default {
    name: 'JobBoards',
    components: {JobBoardList, SimpleButton},
    data() {
        return {
            noIntegration: true
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        hasMultiPostingSubscription() {
            return !!this.multiPostingSubscription && this.currentCompany.multiposting_status === 'active';
        },
        multiPostingSubscription() {
            return useRepo(PaidSubscription)
                .where('type', 'multi-posting')
                .where('company_id', this.currentCompany.id)
                .where('active', true)
                .first();
        },
    },
    methods: {
        ...mapActions(useMultiPostingStore, ['addSelectedItems']),
        addToCampaign(product) {
            this.addSelectedItems([{
                id: product.id,
                channel_id: product.channel_id,
                name: product.name,
                price: {
                    amount: product.vonq_price[0].amount,
                    currency: product.vonq_price[0].currency
                },
                duration: product.duration,
                type: 'product',
                logo_square_url: product.logo_square_url,
                time_to_process: product.time_to_process,
                time_to_setup: product.time_to_setup
            }]);
            this.$emit('change-tab', {tab: 'Campaigns', params: 'create'});
        }
    }
}
</script>
